import React, { Component, createRef } from 'react';
import {
    Button,
    Input,
    Form,
    FormGroup,
    Card,
    CardBody,
    CardHeader,
    CardFooter,
} from 'reactstrap';
import { Field, Formik } from 'formik';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import axios from 'axios';
import { API_URL } from 'helpers/app_url';
import SafeField from "helpers/SafeField";
import TemplateSelector from './TemplateDropdown';
// 📧 Validation schema using Yup
const ComposeSchema = Yup.object().shape({
    to: Yup.string().email('Invalid email').required('Recipient email is required'),
    subject: Yup.string().required('Subject is required'),
});

// ✅ Allowed safe file types
const ALLOWED_FILE_TYPES = [
    // Images
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/webp',
    // Documents
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'text/plain',
];

export default class ComposeClientMail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            attachments: [],
            showCcBcc: false,
            isMinimized: false,
        };
        this.bodyRef = createRef();
        this.fileInputRef = createRef();
    }

    componentDidMount() {
        if (this.bodyRef.current) this.bodyRef.current.focus();
        this.fetchAllTemplates();
    }

      fetchAllTemplates() {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const token = obj?.resultData?.bearerToken;
        const headers = {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        };
    
        const params = {
          AgentId: localStorage.getItem('userId'),
    
        };
        axios
          .get(`${API_URL}AgentCustomEmailTemplate/allAgent`, { headers, params })
          .then((response) => {
            this.setState({ templates: response.data, loadings: false });
          })
          .catch((error) => {
            this.setState({ error: error.message, loadings: false });
          });
      }
    // ✅ FIXED: moved inside class and bound to `this`
    handleAttachmentFiles = (files) => {
        const safeFiles = Array.from(files).filter((file) => {
            if (ALLOWED_FILE_TYPES.includes(file.type)) {
                return true;
            } else {
                alert(`"${file.name}" is not allowed. Only images, documents, and PDFs are accepted.`);
                return false;
            }
        });

        const arr = safeFiles.map((file) => {
            const isImage = file.type.startsWith('image/');
            const previewUrl = isImage ? URL.createObjectURL(file) : null;
            return { id: Date.now() + Math.random(), file, previewUrl, isImage };
        });

        this.setState((prev) => ({
            attachments: [...prev.attachments, ...arr],
        }));
    };

    handleFileChange = (e) => {
        this.handleAttachmentFiles(e.target.files);
        e.target.value = null;
    };

    removeAttachment = (id) => {
        this.setState((prev) => ({
            attachments: prev.attachments.filter((a) => a.id !== id),
        }));
    };

    applyFormat = (cmd, value = null) => {
        document.execCommand(cmd, false, value);
        this.bodyRef.current && this.bodyRef.current.focus();
    };

    handleSend = (values) => {
        const bodyHtml = this.bodyRef.current ? this.bodyRef.current.innerHTML : '';
        const payload = { ...values, bodyHtml, attachments: this.state.attachments };

        if (this.props.onSend) this.props.onSend(payload);

        // reset
        this.setState({ attachments: [] });
        if (this.bodyRef.current) this.bodyRef.current.innerHTML = '';
    };

    handleDiscard = () => {
        if (!window.confirm('Discard draft?')) return;
        this.setState({ attachments: [] });
        if (this.bodyRef.current) this.bodyRef.current.innerHTML = '';
        if (this.props.onClose) this.props.onClose();
    };
handleTemplateSelect = (e, setFieldValue) => {
  const selectedTemplateId = e.target.value;
  if (!selectedTemplateId) return;

  const obj = JSON.parse(localStorage.getItem("authUser"));
  const token = obj?.resultData?.bearerToken;
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  axios
    .get(`${API_URL}AgentCustomEmailTemplate/GetAgentCustomEmailTemplateByGuid`, {
      headers,
      params: { id: selectedTemplateId },
    })
    .then((response) => {
      const template = response.data;
      if (template) {

        setFieldValue("subject", template.templateEmailSubject || "");
        if (this.bodyRef.current) {
          this.bodyRef.current.innerHTML = template.templateEmailBody || "";
        }

        //toast.success("Template loaded successfully!");
      } else {
        toast.dismiss();
        toast.warn("No template data found!");
      }
    })
    .catch((error) => {
      console.error("Error fetching template:", error);
      toast.error("Failed to load template. Try again.");
    });
};
    render() {
        const { attachments, showCcBcc, isMinimized, templates, show } = this.state;
        const { agentData, clientDetail } = this.props;
        //
        return (
            <div
                className="position-fixed bottom-0 end-0 mb-3 me-3"
                style={{ width: '820px', zIndex: 1050 }}
            >
                <Card className="shadow-lg rounded-4 border-0 overflow-hidden">
                    <CardHeader className="d-flex justify-content-between align-items-center bg-warning text-white py-2 px-3">
                        <h6 className="mb-0">New Message</h6>
                        <div>
                            <Button
                                color="link"
                                size="sm"
                                className="text-white text-decoration-none me-2"
                                onClick={() => this.setState({ isMinimized: !isMinimized })}
                            >
                                {isMinimized ? '⬆️' : '➖'}
                            </Button>
                            <Button
                                color="link"
                                size="sm"
                                className="text-white text-decoration-none"
                                onClick={this.handleDiscard}
                            >
                                ✖️
                            </Button>
                        </div>
                    </CardHeader>

                    {!isMinimized && (
                        <Formik
                            initialValues={{
                                to: clientDetail?.prefferedEmail || '',
                                cc: '',
                                bcc: '',
                                subject: '',
                                agentId: agentData.agentId || '',
                            }}
                            validationSchema={ComposeSchema}
                            onSubmit={(values, { setSubmitting, resetForm }) => {
                                const bodyHtml = this.bodyRef.current ? this.bodyRef.current.innerHTML : '';
                                toast.loading("Please wait...");


                                const obj = JSON.parse(localStorage.getItem("authUser"));
                                const token = obj?.resultData?.bearerToken;


                                const formData = new FormData();
                                formData.append("to", values.to);
                                formData.append("cc", values.cc || "");
                                formData.append("bcc", values.bcc || "");
                                formData.append("subject", values.subject);
                                formData.append("body", bodyHtml);
                                formData.append("agentId", values.agentId || "");

                                this.state.attachments.forEach((fileObj) => {
                                    formData.append("files", fileObj.file, fileObj.file.name);
                                });

                                this.setState({ isLoading: true });

                                // 🚀 Submit to API
                                axios
                                    .post(`${API_URL}Gmail`, formData, {
                                        headers: {
                                            "Content-Type": "multipart/form-data",
                                            Authorization: `Bearer ${token}`,
                                        },
                                    })
                                    .then((response) => {
                                        toast.dismiss();
                                        toast.success("Sent successfully!");
                                        resetForm();
                                        this.setState({ attachments: [], isLoading: false });
                                        if (this.bodyRef.current) this.bodyRef.current.innerHTML = "";
                                        if (this.props.onClose) this.props.onClose();
                                    })
                                    .catch((error) => {
                                     
                                        toast.dismiss();
                                        toast.error("Failed to send email. Please try again.");
                                        this.setState({ isLoading: false });
                                    })
                                    .finally(() => {
                                        setSubmitting(false);
                                    });
                            }}
                        >
                            {({
                                values,
                                errors,
                                touched,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                setFieldValue 
                            }) => (
                                <>
                                    <CardBody className="p-3" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                                        <Form onSubmit={handleSubmit}>
                                            {/* To Field */}
                                            <FormGroup className="mb-2">
                                                <SafeField
                                                    type="text"
                                                    name="to"
                                                    value={values.to}
                                                    placeholder="To"
                                                    disabled={clientDetail?.prefferedEmail ? true : false}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    className={`form-control ${errors.to && touched.to ? 'is-invalid' : ''
                                                        }`}
                                                />
                                                {errors.to && touched.to && (
                                                    <div className="text-danger small mt-1">{errors.to}</div>
                                                )}
                                            </FormGroup>

                                            {/* CC/BCC */}
                                            {showCcBcc && (
                                                <>
                                                    <FormGroup className="mb-2">
                                                        <SafeField
                                                            type="text"
                                                            name="cc"
                                                            placeholder="Cc"
                                                            onChange={handleChange}
                                                            className="form-control"
                                                        />
                                                    </FormGroup>
                                                    <FormGroup className="mb-2">
                                                        <SafeField
                                                            type="text"
                                                            name="bcc"
                                                            placeholder="Bcc"
                                                            value={values.bcc}
                                                            onChange={handleChange}
                                                            className="form-control"
                                                        />
                                                    </FormGroup>
                                                </>
                                            )}
                                            {!showCcBcc && (
                                                <div
                                                    className="mb-2 text-primary small cursor-pointer"
                                                    onClick={() => this.setState({ showCcBcc: true })}
                                                >
                                                    Add Cc/Bcc
                                                </div>
                                            )}

                                            {/* Subject */}
                                            <FormGroup className="mb-2">
                                                <SafeField
                                                    type="text"
                                                    name="subject"
                                                    placeholder="Subject"
                                                    value={values.subject}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    className={`form-control ${errors.subject && touched.subject ? 'is-invalid' : ''
                                                        }`}
                                                />
                                                {errors.subject && touched.subject && (
                                                    <div className="text-danger small mt-1">{errors.subject}</div>
                                                )}
                                            </FormGroup>

                                            {/* Toolbar */}
                                            <div className="border rounded bg-light p-1 mb-2 d-flex gap-1 align-items-center">
                                                <Button size="sm" color="light" onClick={() => this.applyFormat('bold')}>
                                                    <b>B</b>
                                                </Button>
                                                <Button size="sm" color="light" onClick={() => this.applyFormat('italic')}>
                                                    <i>I</i>
                                                </Button>
                                                <Button size="sm" color="light" onClick={() => this.applyFormat('underline')}>
                                                    <u>U</u>
                                                </Button>
                                                <Button size="sm" color="light" onClick={() => this.applyFormat('insertUnorderedList')}>
                                                    • List
                                                </Button>
                                                <Button size="sm" color="light" onClick={() => this.applyFormat('insertOrderedList')}>
                                                    1. List
                                                </Button>
                                                <div className='ms-auto'>
                                                    <div className='d-flex gap-4 align-items-center'>
                                                          <TemplateSelector
                                                        templates={templates}
                                                        setFieldValue={setFieldValue}
                                                        values={values}
                                                        handleTemplateSelect={this.handleTemplateSelect}
                                                    />
                                                    {/* <select className='form-select'
                                                    onChange={(e) => this.handleTemplateSelect(e, setFieldValue)}
                                                    >
                                                        <option value="">Select Templates</option>
                                                         {templates?.map((template, index) => (
                                                            <option key={index} value={template.templateId}>
                                                                {template.templateTitle}
                                                            </option>
                                                        ))} 
                                                    </select> */}

                                                     <Button
                                                        outline
                                                        size="sm"
                                                        color="dark"
                                                        style={{width:150}}
                                                        onClick={() =>
                                                            this.fileInputRef.current && this.fileInputRef.current.click()
                                                        }
                                                    >
                                                        📎 Attach
                                                    </Button>
                                                    <input
                                                        ref={this.fileInputRef}
                                                        type="file"
                                                        multiple
                                                        accept=".jpg,.jpeg,.png,.gif,.webp,.pdf,.doc,.docx,.xls,.xlsx,.txt"
                                                        onChange={this.handleFileChange}
                                                        className="d-none"
                                                    />
                                                </div>
                                               </div>
                                            </div>

                                            {/* Editable Body */}
                                            <div
                                                ref={this.bodyRef}
                                                contentEditable
                                                suppressContentEditableWarning
                                                className="border rounded p-2 mb-3"
                                                style={{ minHeight: '250px', whiteSpace: 'pre-wrap' }}
                                            ></div>

                                            {/* Attachments Display */}
                                            {attachments.length > 0 && (
                                                <div className="border rounded p-2 bg-light mb-2">
                                                    <h6 className="small mb-2">Attachments</h6>
                                                    <div className="d-flex flex-wrap gap-2">
                                                        {attachments.map((a) => (
                                                            <div
                                                                key={a.id}
                                                                className="position-relative border rounded p-2 bg-white text-center"
                                                                style={{
                                                                    width: '100px',
                                                                    height: '100px',
                                                                    overflow: 'hidden',
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    fontSize: '12px',
                                                                }}
                                                            >
                                                                {a.isImage ? (
                                                                    <img
                                                                        src={a.previewUrl}
                                                                        alt={a.file.name}
                                                                        style={{
                                                                            width: '80px',
                                                                            height: '80px',
                                                                            objectFit: 'cover',
                                                                        }}
                                                                    />
                                                                ) : (
                                                                    <div className="text-center">
                                                                        {a.file.type === 'application/pdf' && '📕'}
                                                                        {a.file.type.includes('word') && '📘'}
                                                                        {a.file.type.includes('excel') && '📊'}
                                                                        {a.file.type === 'text/plain' && '📄'}
                                                                        <div
                                                                            className="text-truncate small"
                                                                            style={{ maxWidth: '90px' }}
                                                                        >
                                                                            {a.file.name}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                <Button
                                                                    close
                                                                    onClick={() => this.removeAttachment(a.id)}
                                                                    className="position-absolute top-0 end-0"
                                                                    style={{ fontSize: '0.8rem', lineHeight: '1' }}
                                                                />
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </Form>
                                    </CardBody>

                                    <CardFooter className="d-flex justify-content-between align-items-center bg-light py-2 px-3">
                                        <div>
                                            <Button color="primary" size="sm" className="me-2" type="submit" onClick={handleSubmit}>
                                                Send
                                            </Button>
                                            {/* <Button outline color="secondary" size="sm" onClick={this.handleDiscard}>
                        Discard
                      </Button> */}
                                        </div>
                                    </CardFooter>
                                </>
                            )}
                        </Formik>
                    )}
                </Card>
            </div>
        );
    }
}

ComposeClientMail.propTypes = {
    onSend: PropTypes.func,
    onClose: PropTypes.func,
    agentData: PropTypes.object,
    clientDetail: PropTypes.object,
};
